import { render, staticRenderFns } from "./LotSire.vue?vue&type=template&id=2bda174c&"
import script from "./LotSire.vue?vue&type=script&lang=js&"
export * from "./LotSire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports